import {
  DownloadFileRecurringResponse,
  getFileRecurring,
  SuccessResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import downloadFile, { base64DownloadXlsx } from '../../utils/file';
import { handleNotAuthorized, Self } from '../common';

function* DownloadFileRecurringRequest(
  self: Self,
  fileName: string
): Generator<Promise<FlowReturn<DownloadFileRecurringResponse>>> {
  self.isLoading = true;
  try {
    const response = yield getFileRecurring(fileName);
    const { data, status } = (response as DownloadFileRecurringResponse).data;
    if (data?.file_content) {
      base64DownloadXlsx(data.file_content, data.file_name, downloadFile);
      return Promise.resolve(ResponseMessage.OK);
    }
    if (status.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default DownloadFileRecurringRequest;
